import { render, staticRenderFns } from "./LessonUpload.vue?vue&type=template&id=3e4b9cae&"
import script from "./LessonUpload.vue?vue&type=script&lang=ts&"
export * from "./LessonUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports